import React from 'react';
import CounterStyled from './bundle.esm3.js';
import { defaultFunction } from '../../utils/bundle.esm2.js';
import useCounter from './bundle.esm2.js';
import Button from '../Button/bundle.esm.js';
import Add from '../../assets/images/counter/bundle.esm.js';
import Minus from '../../assets/images/counter/bundle.esm2.js';

const Counter = (props) => {
  const { className, disabled = false, steps = 1 } = props;
  const { min = 0, max = 100, initialValue = 0 } = props;
  const { onChange = defaultFunction, onAdd = defaultFunction } = props;
  const { onSubtract = defaultFunction } = props;
  const { minDisabled: minDisabledProp = false } = props;
  const { maxDisabled: maxDisabledProp = false } = props;
  const config = {
    min,
    max,
    steps,
    initialValue,
    onChange,
    onAdd,
    onSubtract
  };
  const { add, subtract, quantity } = useCounter(config);
  const minDisabled = quantity <= min || disabled || minDisabledProp;
  const maxDisabled = quantity >= max || disabled || maxDisabledProp;
  return /* @__PURE__ */ React.createElement(CounterStyled, {
    className: `Counter ${className}`
  }, /* @__PURE__ */ React.createElement(Button, {
    className: "Counter__button",
    onClick: subtract,
    disabled: minDisabled,
    type: "BORDER"
  }, /* @__PURE__ */ React.createElement(Minus, null)), /* @__PURE__ */ React.createElement("div", {
    className: "Counter__quantity"
  }, quantity), /* @__PURE__ */ React.createElement(Button, {
    className: "Counter__button",
    onClick: add,
    disabled: maxDisabled,
    type: "BORDER"
  }, /* @__PURE__ */ React.createElement(Add, null)));
};
Counter.defaultProps = {
  className: "",
  steps: 1,
  min: 0,
  max: 100,
  initialValue: 0,
  onAdd: defaultFunction,
  onSubtract: defaultFunction,
  onChange: defaultFunction,
  minDisabled: false,
  maxDisabled: false
};

export { Counter as default };
//# sourceMappingURL=bundle.esm.js.map
